/**
 * Build a chat/LLM API URL that works with the shared axios `api` instance.
 * NEXT_CHAT_API_URL is often a relative proxy (`/llm-proxy`). If we pass that
 * relative path to axios (baseURL = backend), requests wrongly hit
 * `/rest-api/llm-proxy/...` on the Nest backend instead of Next.js.
 */
export function chatApiUrl(path: string): string {
  const base = (process.env.NEXT_CHAT_API_URL || '/llm-proxy').replace(
    /\/$/,
    ''
  );
  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (base.startsWith('http://') || base.startsWith('https://')) {
    return `${base}${normalized}`;
  }

  if (typeof window !== 'undefined') {
    return `${window.location.origin}${base}${normalized}`;
  }

  return `${base}${normalized}`;
}
